export interface Token {
  access_token: string;
  refresh_token: string;
  token_type: string;
  expires_in: number;
  last_token_refresh: number;
}


export interface Usuario {

  CUSRID: string;
  CUSRNOME: string;
  CUSREMAIL: string;
  CUSRCODIGO: string;
  AEMPRESA: Array<Empresa>;
  AGRUPO: Array<Grupo>;
  APRIVILEGIO: Array<Privilegio>;
  AGRUPOECONOMICO: Array<GrupoEconomico>;
  CDADOSULTIMOACESSO: string;
}

export interface Grupo {
  CGRPCODIGO: string;
  CGRPNOME: string;
}

export interface GrupoEconomico {
  CM0CODIGO: string;
  CM0NOME: string;
}

export interface Empresa {
  CM0TEL: string;
  CM0NOMECOM: string;
  CM0CGC: string;
  CM0ESTENT: string;
  CM0NOME: string;
  CM0CODFIL: string;
  CM0FILIAL: string;
  CM0CODIGO: string;
}

export interface Privilegio {
  CCODIGO: string;
}


export interface UsuarioBase {

  CUSRID: string;
  CUSRNOME: string;
  CUSREMAIL: string;
  CUSRCODIGO: string;

}

export const defaultUsuario = (): Usuario => {
  return {
    CUSRID: '',
    CUSRNOME: '',
    CUSREMAIL: '',
    CUSRCODIGO: '',
    AEMPRESA: [],
    AGRUPO: [],
    APRIVILEGIO: [],
    AGRUPOECONOMICO: [],
    CDADOSULTIMOACESSO: '',
  }
}

export interface IP {
  ip: string;
}
